import { gql } from '@apollo/client';

const MASK_DEVICE_PATIENT_RETURNED = gql`
  mutation markDevicePatientReturned($input: MarkDevicePatientReturnedInput!) {
    markDevicePatientReturned(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MASK_DEVICE_PATIENT_RETURNED;
